
define('template!pimProductEditsTabTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (allowEditCompuzz) { ;
__p += '\n<div class="pim-actions-bar">\n    <button class="btn-action btn-edit-supplier-product">\n        <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 512 512"><path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 #410.2 95l14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0z"/></svg>\n        ' +
((__t = ( _.i18n('common.editCompuzzProduct') )) == null ? '' : __t) +
'\n    </button>\n    <button class="btn-action btn-action-warning btn-force-update-compuzz-product">\n        <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 512 512"><path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 .1 0 .1 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-17.5-17.5H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-3.2 0-6.4 .4-9.4 1.3z"/></svg>\n        ' +
((__t = ( _.i18n('common.forceUpdateCompuzzProduct') )) == null ? '' : __t) +
'\n    </button>\n</div>\n';
 } ;
__p += '\n\n<div class="pim-product-hero">\n    <div class="pim-hero-image">\n        <div class="pim-section-label">' +
((__t = ( _.i18n('pictures.catalogPicture') )) == null ? '' : __t) +
'</div>\n        <div class="edit-image"></div>\n    </div>\n    <div class="pim-hero-details">\n        <div class="pim-section-label">' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</div>\n        <div class="pim-detail-card">\n            <div class="pim-detail-code">' +
((__t = ( data.code )) == null ? '' : __t) +
'\n                ';
 if (isPrint) { ;
__p += '\n                <span class="pim-badge-print" title="' +
__e( _.i18n('pim.print.badgeHint', null, 'Configurable print product: no print area, the customer sends a ready-to-print file') ) +
'">PRINT</span>\n                ';
 } ;
__p += '\n            </div>\n            <div class="pim-detail-rows">\n                <div class="pim-detail-row">\n                    <span class="pim-detail-label">' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</span>\n                    <span class="pim-detail-value">' +
((__t = ( name )) == null ? '' : __t) +
'</span>\n                </div>\n                <div class="pim-detail-row">\n                    <span class="pim-detail-label">' +
((__t = ( _.i18n('common.description') )) == null ? '' : __t) +
'</span>\n                    <span class="pim-detail-value">' +
((__t = ( description )) == null ? '' : __t) +
'</span>\n                </div>\n                <div class="pim-detail-row">\n                    <span class="pim-detail-label">' +
((__t = ( _.i18n('common.brand') )) == null ? '' : __t) +
'</span>\n                    <span class="pim-detail-value">' +
((__t = ( data.brand )) == null ? '' : __t) +
'</span>\n                </div>\n                ';
 if (!isPrint) { /* A PRINT product's size and weight depend on the configuration */ ;
__p += '\n                <div class="pim-detail-row pim-detail-row-group">\n                    <div class="pim-detail-measure">\n                        <span class="pim-detail-label">' +
((__t = ( _.i18n('common.width') )) == null ? '' : __t) +
'</span>\n                        <span class="pim-detail-value">' +
((__t = ( data.refRootProduct.width )) == null ? '' : __t) +
' mm</span>\n                    </div>\n                    <div class="pim-detail-measure">\n                        <span class="pim-detail-label">' +
((__t = ( _.i18n('common.height') )) == null ? '' : __t) +
'</span>\n                        <span class="pim-detail-value">' +
((__t = ( data.refRootProduct.height )) == null ? '' : __t) +
' mm</span>\n                    </div>\n                    <div class="pim-detail-measure">\n                        <span class="pim-detail-label">' +
((__t = ( _.i18n('common.deepness') )) == null ? '' : __t) +
'</span>\n                        <span class="pim-detail-value">' +
((__t = ( data.refRootProduct.deepness )) == null ? '' : __t) +
' mm</span>\n                    </div>\n                </div>\n                <div class="pim-detail-row">\n                    <span class="pim-detail-label">' +
((__t = ( _.i18n('common.weight') )) == null ? '' : __t) +
'</span>\n                    <span class="pim-detail-value">' +
((__t = ( data.refRootProduct.weight )) == null ? '' : __t) +
' gr</span>\n                </div>\n                ';
 } ;
__p += '\n                <div class="pim-detail-row">\n                    <span class="pim-detail-label">' +
((__t = ( _.i18n('common.minimumOrderQuantity') )) == null ? '' : __t) +
'</span>\n                    <span class="pim-detail-value">' +
((__t = ( data.minimumOrderQuantity )) == null ? '' : __t) +
'</span>\n                </div>\n                ';
 if (data.fastDelivery) { ;
__p += '\n                <div class="pim-detail-row">\n                    <span class="pim-detail-label">' +
((__t = ( _.i18n('common.fastDelivery') )) == null ? '' : __t) +
'</span>\n                    <span class="pim-detail-value pim-badge-yes">' +
((__t = ( _.i18n('common.yes') )) == null ? '' : __t) +
'</span>\n                </div>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="pim-gallery-section">\n    <div class="images-region"></div>\n</div>\n\n';
 if (attachments.length) { ;
__p += '\n<div class="pim-section">\n    <div class="pim-section-header">\n        <div class="pim-section-label">' +
((__t = ( _.i18n('common.attachments') )) == null ? '' : __t) +
' (' +
((__t = ( attachments.length )) == null ? '' : __t) +
')</div>\n    </div>\n    <div class="pim-attachments">\n        ';
 _.each(attachments, function (att) { ;
__p += '\n        <a class="pim-attachment" href="' +
__e( att.url ) +
'" target="_blank" rel="noopener noreferrer" title="' +
__e( att.name ) +
'">\n            <span class="pim-attachment-preview">\n                ';
 if (att.isImage) { ;
__p += '\n                <img src="' +
__e( att.url ) +
'" alt="" loading="lazy">\n                ';
 } else { ;
__p += '\n                <span class="pim-attachment-ext">' +
__e( att.extension || 'FILE' ) +
'</span>\n                ';
 } ;
__p += '\n            </span>\n            <span class="pim-attachment-name">' +
__e( att.name ) +
'</span>\n        </a>\n        ';
 }) ;
__p += '\n    </div>\n</div>\n';
 } ;
__p += '\n\n';
 if (isPrint) { ;
__p += '\n<div class="pim-section">\n    <div class="pim-section-header">\n        <div class="pim-section-label">' +
__e( _.i18n('pim.print.configurator', null, 'Configurator') ) +
'</div>\n    </div>\n    <div class="pim-print-summary">\n        <ol class="pim-print-steps">\n            ';
 _.each(printSummary.steps, function (step) { ;
__p += '\n            <li><span class="pim-print-step-name">' +
__e( step.name ) +
'</span> <span class="pim-print-step-count">' +
__e( step.count ) +
'</span></li>\n            ';
 }) ;
__p += '\n        </ol>\n        <div class="pim-print-stats">\n            ' +
__e( printSummary.combinations ) +
' ' +
__e( _.i18n('pim.print.combinations', null, 'combinations') ) +
',\n            ' +
__e( printSummary.withTemplate ) +
' ' +
__e( _.i18n('pim.print.withTemplate', null, 'with a template') ) +
'\n        </div>\n    </div>\n</div>\n';
 } else { ;
__p += '\n<div class="pim-section">\n    <div class="pim-section-header">\n        <div class="pim-section-label">Print areas</div>\n        <button class="btn-position-areas" title="' +
((__t = ( _.i18n('pimPositioner.openHint', null, 'Place the print areas on the product pictures, for proofsheets made from the PIM') )) == null ? '' : __t) +
'">\n            ' +
((__t = ( _.i18n('pimPositioner.open', null, 'Position print areas') )) == null ? '' : __t) +
'\n        </button>\n    </div>\n    <div class="edit-printareas"></div>\n</div>\n';
 } ;
__p += '\n\n<div class="pim-section">\n    <div class="pim-section-header">\n        <div class="pim-section-label">Options categories</div>\n        <button class="btn-save-options-categories">' +
((__t = ( _.i18n('common.save') )) == null ? '' : __t) +
'</button>\n    </div>\n    <div class="edit-cats"></div>\n</div>\n\n<div class="pim-section">\n    <div class="pim-section-header">\n        <div class="pim-section-label">Variations</div>\n    </div>\n    <div class="edit-variations"></div>\n</div>\n\n<div class="loading-block js-loading-block loader"></div>\n';

}
return __p
};});

